module.exports = __webpack_public_path__ + "img/back-arrow.3cc0c357.svg";